// extracted by mini-css-extract-plugin
module.exports = {"title":"menu-module--title--c5_ve footer-module--title--33RQI","item":"menu-module--item--m8F3u footer-module--item--23hDx","list":"menu-module--list--Rom3e"};